const article = {
  "article.title": "Basetao Spreadsheet Ratgeber: Was es ist & wie es funktioniert",
  "article.meta.description":
    "Erfahre, was ein Basetao Spreadsheet ist, was darin enthalten ist und wie du es nutzt, um Produkte, Verkäufer und Kategorien beim Bestellen über Basetao zu vergleichen.",
  "article.breadcrumb": "Spreadsheet-Ratgeber",
  "article.h1": "Basetao Spreadsheet Ratgeber: Was es ist & wie es funktioniert",

  "article.author": "Von:",
  "article.author.name": "Basetao Sheet Redaktionsteam",
  "article.published": "Veröffentlicht:",
  "article.updated": "Aktualisiert:",
  "article.date": "18. August 2026",

  "article.intro":
    "Ein Basetao Spreadsheet ist eine geteilte, organisierte Liste aus Produktlinks, Kategorien, Verkäufern und Notizen, die Käufer nutzen, um über Basetao bestellte Artikel zu finden und zu vergleichen. Kurz gesagt verwandelt es einen großen, verstreuten Katalog in einen ordentlichen Ausgangspunkt, den du filtern, sortieren und teilen kannst. Dieser Ratgeber erklärt, was typischerweise darin steht, wie man es liest und wie man damit effizienter einkauft.",

  "article.toc.title": "Auf dieser Seite",
  "article.toc.1": "Was ist ein Basetao Spreadsheet?",
  "article.toc.2": "Was du darin findest",
  "article.toc.3": "So nutzt du ein Basetao Spreadsheet",
  "article.toc.4": "Warum Käufer auf eine Tabelle setzen",
  "article.toc.5": "Tipps für den besten Nutzen",
  "article.toc.6": "Häufig gestellte Fragen",

  "article.s1.h2": "Was ist ein Basetao Spreadsheet?",
  "article.s1.p1":
    "Basetao ist ein Einkaufsagent, der Käufern außerhalb Chinas hilft, auf Marktplätzen wie Taobao, Weidian und 1688 zu bestellen und die Artikel international zu versenden. Ein Basetao Spreadsheet ist eine ergänzende Ressource: eine Liste, die bereits erstellt und geteilt wurde und Links zu bestimmten Produkten, deren Kategorien, Verkäufern und hilfreichen Notizen enthält.",
  "article.s1.p2":
    "Stell es dir als kuratierte Karte des Katalogs vor, nicht als den Katalog selbst. Statt hunderte Seiten zu durchsuchen, beginnst du mit einer Auswahl an Artikeln, die andere Käufer bereits gefunden und oft geprüft haben. Das spart Zeit und gibt dir eine gezieltere Möglichkeit, deine Optionen zu vergleichen.",

  "article.s2.h2": "Was du in einem Basetao Spreadsheet findest",
  "article.s2.p1":
    "Tabellen variieren, aber die meisten gut gemachten basieren auf einigen einheitlichen Spalten. Hier ist, was jede Spalte bedeutet und warum sie hilft.",
  "article.s2.table.c1": "Spalte",
  "article.s2.table.c2": "Was sie zeigt",
  "article.s2.table.c3": "Warum sie hilft",
  "article.s2.r1.c1": "Produkt",
  "article.s2.r1.c2": "Der bestimmte Artikel und sein Link",
  "article.s2.r1.c3": "Direkt zum gewünschten Artikel springen",
  "article.s2.r2.c1": "Kategorie",
  "article.s2.r2.c2": "Zu welcher Gruppe der Artikel gehört",
  "article.s2.r2.c3": "Schuhe, Hoodies, Taschen und mehr filtern",
  "article.s2.r3.c1": "Verkäufer",
  "article.s2.r3.c2": "Der Name des Shops oder Verkäufers",
  "article.s2.r3.c3": "Verlässliche Verkäufer erkennen",
  "article.s2.r4.c1": "Notizen / QC",
  "article.s2.r4.c2": "Qualitätskontroll- und andere Hinweise",
  "article.s2.r4.c3": "Probleme vor der Bestellung vermeiden",

  "article.s3.h2": "So nutzt du ein Basetao Spreadsheet",
  "article.s3.p1":
    "Du brauchst keine speziellen Tools, um eine Tabelle zu nutzen. Folge diesen vier Schritten, um von einer Liste zu einer sicheren Bestellung zu kommen.",
  "article.s3.step1.title": "1. Beginne mit einer Kategorie",
  "article.s3.step1.text":
    "Filtere die Tabelle nach der Kategorie, die dich interessiert — Schuhe, T-Shirts, Jacken, Taschen oder Accessoires —, sodass du nur relevante Zeilen siehst.",
  "article.s3.step2.title": "2. Prüfe die Notizen",
  "article.s3.step2.text":
    "Lies die Verkäufer- und Qualitätskontroll-Notizen zu einem Produkt. Diese Hinweise betreffen oft Größe, Qualität oder Versanddetails.",
  "article.s3.step3.title": "3. Öffne den Produktlink",
  "article.s3.step3.text":
    "Nutze den Produktlink, um den Artikel auf der Hauptseite anzusehen und Preis, Fotos und Verfügbarkeit zu bestätigen, bevor du dich festlegst.",
  "article.s3.step4.title": "4. Vor dem Kauf vergleichen",
  "article.s3.step4.text":
    "Stelle zwei oder drei ähnliche Artikel nebeneinander, um Verkäufer und Details zu vergleichen, und wähle dann den passendsten.",

  "article.s4.h2": "Warum Käufer auf eine Tabelle setzen",
  "article.s4.p1":
    "Der Hauptgrund ist einfach: Eine Tabelle nimmt den größten Teil der Browsing-Reibung weg. Statt Seite um Seite zu öffnen und dir zu merken, was du gesehen hast, erhältst du eine einzige, sortierbare Ansicht von Produkten, Kategorien, Verkäufern und Notizen. Das ist besonders hilfreich, wenn du neu bei einem Einkaufsagenten bist, denn die Liste bietet dir einen bereits organisierten Ausgangspunkt, und die Notizen können dir helfen, häufige Fehler wie das Übersehen der Größe oder die Wahl eines unzuverlässigen Verkäufers zu vermeiden.",

  "article.s5.h2": "Tipps für den besten Nutzen",
  "article.s5.p1": "Behalte diese Gewohnheiten im Kopf, damit die Tabelle mehr für dich arbeitet.",
  "article.s5.t1": "Vor der Bestellung prüfen — Links und Preise können sich ändern, bestätige den Artikel immer auf der Produktseite.",
  "article.s5.t2": "Nutze die Kategorien, um deine Suche einzugrenzen, statt die ganze Liste zu scrollen.",
  "article.s5.t3": "Ergänze beim Vergleichen deine eigenen Notizen, damit deine Auswahl organisiert bleibt.",
  "article.s5.t4": "Setze Lesezeichen für Artikel, die dir gefallen, um später zurückzukommen.",

  "article.s6.h2": "Häufig gestellte Fragen",
  "article.s6.q1": "Brauche ich ein Basetao-Konto, um die Tabelle zu nutzen?",
  "article.s6.a1":
    "Nein. Du kannst die Tabelle frei lesen und nutzen. Ein Konto brauchst du nur, wenn du über einen Einkaufsagenten oder die Hauptseite bestellen möchtest.",
  "article.s6.q2": "Sind die Produkte in der Tabelle immer verfügbar?",
  "article.s6.a2":
    "Verfügbarkeit, Preise und Verkäuferdaten können sich mit der Zeit ändern. Die Tabelle ist ein guter Ausgangspunkt, aber bestätige die aktuellen Details immer auf der Produktseite.",

  "article.s7.h2": "Fazit",
  "article.s7.p1":
    "Ein Basetao Spreadsheet ist eine der einfachsten Möglichkeiten, über einen Einkaufsagenten zu bestellen, ohne bei null anzufangen. Indem es dir eine strukturierte Liste aus Produkten, Kategorien, Verkäufern und Notizen bietet, hilft es dir, Zeit zu sparen, leichter zu vergleichen und sicherere Entscheidungen zu treffen. Beginne mit einer Kategorie, prüfe die Notizen und bestätige die Produktseite vor dem Kauf.",

  "article.cta.text": "Bereit zum Stöbern? Entdecke den ganzen Katalog auf der Hauptseite.",
  "article.cta.button": "Jetzt kaufen",
  "article.backHome": "Zurück zur Startseite",
};

export default article;